import {
  collection,
  onSnapshot,
  query,
  where,
} from 'firebase/firestore';
import { db, functions, httpsCallable } from '@/firebase';

export const OPEN_ACTION_SESSION_STATUSES = new Set([
  'scheduled',
  'started',
  'in_progress',
  'recovery_required',
  'recovering',
]);

export function isActionSessionRecord(record) {
  return record?.recordKind !== 'attendance_recovery_register' &&
    !(record?.origin === 'server_fallback' &&
      record?.rosterMode === 'observed_actions');
}

export async function startActionSession(payload) {
  const callable = httpsCallable(functions, 'startActionSession');
  const result = await callable(payload);
  return result.data;
}

export async function concludeActionSession(payload) {
  const callable = httpsCallable(functions, 'concludeActionSession');
  const result = await callable(payload);
  return result.data;
}

export async function reconcileReportedSession(payload) {
  const callable = httpsCallable(functions, 'saveSessionReport');
  const result = await callable({...payload, reconcileOnly: true});
  return result.data;
}

export async function actionQueueItem({ schoolId, itemId, action, sessionId }) {
  const callable = httpsCallable(functions, 'updateQueueItem');
  const result = await callable({ schoolId, itemId, action, sessionId });
  return result.data;
}

export function subscribeStaffActionSessions({
  schoolId,
  userId,
  onSessions,
  onError,
}) {
  if (!schoolId || !userId) return () => {};
  const sessionsQuery = query(
    collection(db, 'schools', schoolId, 'actionSessions'),
    where('participantUids', 'array-contains', userId)
  );
  return onSnapshot(
    sessionsQuery,
    snapshot => {
      const sessions = snapshot.docs.map(document => ({
        id: document.id,
        ...document.data(),
      }));
      onSessions(sessions);
    },
    onError
  );
}
